import i18n from '@root/src/javascripts/i18n'

const getBaseRouteName = (routeName) => routeName.split('__')[0]

export const localizedRouteName = (name, localeParam) => {
  const baseRouteName = getBaseRouteName(name)
  const { locale, fallbackLocale } = i18n
  const targetLocale = localeParam || locale
  return targetLocale !== fallbackLocale
    ? `${baseRouteName}__${targetLocale}`
    : baseRouteName
}

export const localizedRoute = (
  name,
  routeProps = {},
  localeParam,
) => ({
  ...routeProps,
  name: localizedRouteName(name, localeParam),
})
